import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { userService } from '../services/user-service';

export const AuthGuard: CanActivateFn = (_route, _state) => {
    const userServ = inject(userService);
    return new Promise((resolve, reject) => {
        userServ.getUser().subscribe((data) => {
            if (data) {
                resolve(true);
            }
            reject(false);
        });
    });
};
